import { render, staticRenderFns } from "./AdditivesTable.vue?vue&type=template&id=327bbbd0&scoped=true&"
import script from "./AdditivesTable.vue?vue&type=script&lang=ts&"
export * from "./AdditivesTable.vue?vue&type=script&lang=ts&"
import style0 from "./AdditivesTable.vue?vue&type=style&index=0&id=327bbbd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327bbbd0",
  null
  
)

export default component.exports